import EUJson from './eu-countries.json';
import ConsentOnlyJson from './consent-only-countries.json';

export * from './duration';
export * from './robust-fetch';
export * from './recentDevices';
export * from './safeStorage';
export * from './user-typing';
export * from './shortcut-handler';
export * from './reactNativeMessage';

//! Make sure this list matches the 2-letter codes in Varnish (production.vcl)
export const EUCountries = Object.keys(EUJson);

export function isEUCountryCode(code: string) {
   return EUCountries.includes(code.toUpperCase());
}

//! Make sure this list matches the IS/LI checks in Varnish (production.vcl and development.vcl)
// Countries that need the cookie consent banner but are not served by the EU store.
export const ConsentOnlyCountries = Object.keys(ConsentOnlyJson);

export function isConsentRequiredCountryCode(code: string) {
   return isEUCountryCode(code) || ConsentOnlyCountries.includes(code.toUpperCase());
}
